import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { mdiPencil, mdiTextBoxOutline } from '@mdi/js';

import { CmpsFocusItemSummaryModule } from '../focus-item-summary/focus-item-summary.module';

import { CmpsObservationSummaryComponent } from './observation-summary.component';

@NgModule({
    declarations: [CmpsObservationSummaryComponent],
    imports: [
        CmpsFocusItemSummaryModule,
        CmpsIconModule,
        CmpsButtonModule,
        CmpsTooltipModule,
    ],
    exports: [CmpsObservationSummaryComponent],
})
export class CmpsObservationSummaryModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['pencil', mdiPencil],
            ['text-box-outline', mdiTextBoxOutline],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
